import { styled } from '@volkswagen-onehub/components-core';
import { COLOR_TOKEN } from 'src/components/color-token';

type InputErrorProps = {
	smaller?: boolean;
};

export const InputError = styled.p<InputErrorProps>`
	position: relative;
	background-color: ${COLOR_TOKEN.main.signal.error};
	color: ${COLOR_TOKEN.main.content.inverted};
	padding: 4px 8px;
	height: 26px;
	border-radius: 4px;
	font-size: 12px;
	text-align: left;
	margin-top: ${props => (props.smaller ? '-14px' : '5px')};
	box-sizing: border-box;
	width: ${props => (props.smaller ? 'calc(100% - 33px)' : '100%')};
`;
